import { other_labels_de } from '../other_lables_de'
import { other_labels_fr } from '../other_lables_fr'

export const colors_lm = [
  'var(--red-dark-1)',
  'var(--orange-main)',
  'var(--orange-bright-2)',
  'var(--petrol-bright-1)',
  'var(--petrol-dark-2)',
]

// export const colors_dm = [
//   'var(--red-dark-1)',
//   'var(--orange-main)',
//   'var(--orange-bright-2)',
//   'var(--petrol-bright-1)',
//   'var(--petrol-dark-2)',
// ]
export const colors_dm = ['#FF0043', '#AF4802', '#684B38', '#2E756F', '#1FB5A6']

export const color_key_entries_de = [
  {
    label: other_labels_de.poor,
    color: 'var(--red-dark-1)',
    type: 'circle',
  },

  {
    label: '',
    color: 'var(--orange-main)',
    type: 'circle',
  },

  {
    label: '',
    color: 'var(--orange-bright-2)',
    type: 'circle',
  },

  {
    label: '',
    color: 'var(--petrol-bright-1)',
    type: 'circle',
  },
  {
    label: other_labels_de.rich,
    color: 'var(--petrol-dark-2)',
    type: 'circle',
  },
]

export const color_key_entries_fr = [
  {
    label: other_labels_fr.poor,
    color: 'var(--red-dark-1)',
    type: 'circle',
  },

  {
    label: '',
    color: 'var(--orange-main)',
    type: 'circle',
  },

  {
    label: '',
    color: 'var(--orange-bright-2)',
    type: 'circle',
  },

  {
    label: '',
    color: 'var(--petrol-bright-1)',
    type: 'circle',
  },
  {
    label: other_labels_fr.rich,
    color: 'var(--petrol-dark-2)',
    type: 'circle',
  },
]

export function getColorKeyEntries(
  colorMode: 'light' | 'dark' | undefined,
  lang: 'de' | 'fr',
  first: boolean = false,
  opacities?: number[]
) {
  var key_entries = lang === 'de' ? color_key_entries_de : color_key_entries_fr

  var entries: any = key_entries.map((entry, i) => {
    var ext_first = ''
    if (i === 0) {
      ext_first =
        lang === 'de' ? other_labels_de.poor_first : other_labels_fr.poor_first
    }

    var ext_last = ''
    if (i === key_entries.length - 1) {
      ext_last =
        lang === 'de' ? other_labels_de.rich_first : other_labels_fr.rich_first
    }

    return {
      label:
        first && i === 0
          ? ext_first
          : first && i === key_entries.length - 1
          ? ext_last
          : entry.label,
      color: colorMode === 'dark' ? colors_dm[i] : colors_lm[i],
      opacity: opacities ? opacities[i] : 1,
    }
  })
  return entries
}
